import React from 'react';
import QuestionForm from '../QuestionForm';

const QuestionEdit = () => {
  return <QuestionForm isEdit title="Editar Pregunta" submitText="Modificar" />;
};

export default QuestionEdit;
